import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Dialog,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
} from "@mui/material";
import AccountCircle from "@mui/icons-material/AccountCircle";
import LockIcon from "@mui/icons-material/Lock";

import axios from "axios";
import { BASE_API_URL } from "../const";
import Register from "./Register";

const Auth = ({ onAuthSuccess }) => {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [openRegister, setOpenRegister] = useState(false);
  const [codecName, setCodecName] = useState();

  useEffect(() => {
    const url = window.location.href;
    const domain = url
      .replace(/^https?:\/\//, "")
      .split(".")[0]
      .split("/")[0];
    setCodecName(domain);
  }, []);

  useEffect(() => {
    if (localStorage.getItem("lionsarena.Login"))
      setLogin(localStorage.getItem("lionsarena.Login"));
  }, [localStorage.getItem("lionsarena.Login")]);

  const handleLogin = async () => {
    try {
      const response = await axios.post(`${BASE_API_URL}/api/user/login`, {
        login: login,
        password: password,
      });
      if (response.data.success) {
        const { token } = response.data.data;
        localStorage.setItem("lionsarena.Login", login);
        localStorage.setItem("lionsarena.Token", token);

        onAuthSuccess(); // переход на AppWrapper
      }
    } catch (error) {
      setLogin("");
      setPassword("");
      alert("Неправильный логин или пароль, см. в консоли код ошибки");
      console.error("Ошибка авторизации", error);
    }
  };

  const handleOpenRegister = () => setOpenRegister(true);
  const handleCloseRegister = () => setOpenRegister(false);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      sx={{
        backgroundColor: "#F5F8FA",
        whiteSpace: "pre-line",
        textAlign: "center",
      }}
    >
      {/* Логотип */}
      {/* <img src="/path/to/logo.png" alt="Logo" style={{ marginBottom: 16 }} /> */}

      {/* Заголовок */}
      <Typography variant="h5" color="primary" sx={{ marginBottom: 2 }}>
        Lions Arena Admin panel
      </Typography>
      <Typography variant="h5" color="primary" sx={{ marginBottom: 2 }}>
        {codecName}
      </Typography>

      {/* Поля ввода */}
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap={2}
        width="300px"
      >
        <TextField
          label="Логин"
          variant="outlined"
          value={login}
          onChange={(e) => setLogin(e.target.value)}
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <AccountCircle />
              </InputAdornment>
            ),
          }}
        />
        <TextField
          label="Пароль"
          variant="outlined"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={handleKeyDown}
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LockIcon />
              </InputAdornment>
            ),
          }}
        />
        <Button
          variant="contained"
          color="success"
          onClick={handleLogin}
          fullWidth
        >
          Войти
        </Button>
        <Button variant="contained" onClick={handleOpenRegister}>
          Регистрация
        </Button>
      </Box>

      {/* Диалог регистрации */}
      <Dialog open={openRegister} onClose={handleCloseRegister}>
        <Register
          onClose={handleCloseRegister}
          onRegisterSuccess={onAuthSuccess}
        />
      </Dialog>
    </Box>
  );
};

export default Auth;
